export default {
  props: {
    loadingText: {
      type: String
    }
  }
};